<template>
  <div
    v-if="permission"
    class="panel-card permission-showcase"
  >
    <div class="permission-showcase__body">
      <div class="permission-showcase__title">
        {{ permission.text }}
      </div>
      <div
        v-if="permission.description"
        class="permission-showcase__description"
      >
        {{ permission.description }}
      </div>

      <div
        v-if="includedPermissions.length"
        class="permission-showcase__disclaimer"
      >
        <i class="fas fa-fw fa-info-circle mr-1" />
        {{ $t('permissions.grantsLowerLevelPermissionsDisclaimer') }}
        <a
          href="#"
          class="permission-showcase__disclaimer-link"
          @click.prevent="showIncludedModal = true"
        >
          {{ $t('permissions.showIncludedPermissions') }}
        </a>
      </div>
    </div>

    <BModal
      v-model="showIncludedModal"
      hide-footer
      :title="$t('permissions.includedPermissionsModalTitle')"
    >
      <ul class="permission-showcase__included-list">
        <li
          v-for="included in includedPermissions"
          :key="included.name"
        >
          {{ included.text }}
        </li>
      </ul>
    </BModal>
  </div>
  <div
    v-else
    class="permission-showcase permission-showcase--empty"
  >
    <i class="fas fa-fw fa-wrench permission-showcase__empty-icon" />
    <div class="permission-showcase__empty-text">
      {{ $t('permissions.selectPermissionToPreview') }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PermissionShowcase',
  props: {
    permission: Object,
  },
  data() {
    return {
      showIncludedModal: false,
    };
  },
  computed: {
    ...mapGetters(['permissionTypes']),
    includedPermissions() {
      if (!this.permission) return [];

      const node = this.findNode(this.permissionTypes, this.permission.name);
      if (!node) return [];

      return this.collectDescendants(node);
    },
  },
  methods: {
    findNode(nodes, name) {
      return nodes.reduce((found, node) => {
        if (found) return found;
        if (node.name === name) return node;
        if (node.children) return this.findNode(node.children, name);
        return null;
      }, null);
    },
    collectDescendants(node) {
      return (node.children || []).flatMap(child => [child, ...this.collectDescendants(child)]);
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-card {
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 10px;
  overflow: hidden;
}

.permission-showcase--empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #868e96;
}

.permission-showcase__empty-icon {
  font-size: 1.75rem;
  margin-bottom: 10px;
  color: #ced4da;
}

.permission-showcase__empty-text {
  font-size: 0.85rem;
}

.permission-showcase__title {
  font-weight: 600;
  font-size: 1.05rem;
}

.permission-showcase__description {
  margin-top: 4px;
  font-size: 0.85rem;
  color: #868e96;
  line-height: 1.4;
}

.permission-showcase__disclaimer {
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background-color: #fff8e1;
  color: #8a6d00;
  font-size: 0.8rem;
  line-height: 1.4;
}

.permission-showcase__disclaimer-link {
  font-weight: 600;
  white-space: nowrap;
}

.permission-showcase__included-list {
  padding-left: 18px;
  margin-bottom: 0;

  li {
    padding: 2px 0;
  }
}
</style>
